import { useState, useRef, useEffect } from 'react';
import notification from '../../assets/icons/notification.png';
import DropdownNotification from '../DropdownNotification/DropdownNotification';
import { useNotifications } from 'contexts/NotificationsContext';

const NotificationDropdownWrapper = () => {
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { notifications } = useNotifications();

  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsNotificationDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative avatar-dropdown-container" ref={dropdownRef}>
        <button
            onClick={() => {
              setIsNotificationDropdownOpen((prev) => !prev);
            }}
            className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            aria-label="Notificações do usuário"
            aria-expanded={isNotificationDropdownOpen}
        >
          {notifications.length > 0 && (
              <span className="absolute w-[8px] h-[8px] -top-[-11px] -right-[-15px] bg-laranja rounded-full"/>
            )}
              <img 
                src={notification} 
                alt={'Icone notificação'}
                className="max-h-12 w-auto object-contain cursor-pointer"
              />
        </button>
    
        {isNotificationDropdownOpen && (
            <DropdownNotification setIsNotificationDropdownOpen={setIsNotificationDropdownOpen} />
        )}
    </div>
  );
};

export default NotificationDropdownWrapper;
